export const modifierList = ['sky-it'];

export const ratioModifierList = ['16-9', '16-10', 'hero-preferences-page-not-logged', 'hero-preferences-page-logged'];
